import React, {useEffect, useId} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {formatTime} from "utils/time-utils";
import {ComponentConfigDefault} from "models/dataset-models";
import {TitleOverrideAndDescriptionTemplate} from "../../templates/DataTableCellTemplates";

type DatasetTableTransposedProps = {
    data: Array<any>
    config: ComponentConfigDefault
    currentPage: number

    getPageDates: (page: number) => Array<string>
}

const DatasetTableTransposed = ({data, currentPage, getPageDates, config}: DatasetTableTransposedProps) => {
    const tableId = useId();

    useEffect(() => {
        if (config.hideDateColumn) {
            const table = document.getElementById(tableId);
            if (table) {
                const dateColumn = table.querySelector("thead");
                if (dateColumn) {
                    dateColumn.style.display = "none";
                }
            }
        }
    }, [config]);

    return <div className={"data-table-wrapper"}>
        <DataTable value={data} size={"small"} showGridlines id={tableId}>
            <Column className={config.hideDateColumn?"column-into-header":undefined} header={""} field={"title"}
                    body={(row) => TitleOverrideAndDescriptionTemplate({
                        description: row.description,
                        title: row.title,
                        overriddenTitle: row.overriddenTitle,
                        unit: row.unit
                    })} style={{whiteSpace: "nowrap"}}/>
            {
                getPageDates(currentPage).map(date => {
                    return <Column header={formatTime(date)}
                                   key={date}
                                   field={date}
                                   body={e => e[date] != null ? e[date] : "-"}
                                   style={{width: 0, whiteSpace: "nowrap"}}
                    />
                })
            }
        </DataTable>
    </div>
};

export default DatasetTableTransposed;